import {ApplyOfferDto} from "../../../models/dtos/applyOffer.dto";
import {OfferRequest} from "../../../models/requests/offer.request";
import axios from "../../../utilities/axios";

export const applyOfferRequest = async (request: OfferRequest): Promise<ApplyOfferDto> => {
  try {
    const response = await axios.post<ApplyOfferDto>(
      `${process.env.REACT_APP_BASE_URL}/users/offers/apply`,
      {...request},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
